<template>
  <div class="trade-limits">
    <div class="pc-update">
      <div class="pc-update__info" @click="updateBalances">
        <div>
          <span>{{ $t('pc.trade-limits.last-update') }} {{ dateFormat(updateTime) }}</span>
          <span class="trade-limits__note"> {{ $t('pc.trade-limits.note') }}</span>
        </div>
        <pc-button
          :icon-left-name="!isUpdateDisabled ? 'pc-works': ''"
          :disabled="isUpdateDisabled"
          class="pc-update__btn"
          variant="void"
        >
          <icu-icon v-if="isUpdateDisabled" class="pc-small-loader"></icu-icon>
          <template v-else>
            {{ $t('pc.trade-limits.update') }}
          </template>
        </pc-button>
      </div>
    </div>

    <div class="pc-funds">

      <pc-block class="pc-fund pc-funds__available" :class="{'is-opened':availableIsOpened}">
        <svg
          class="pc-icon"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="availableIsOpened = !availableIsOpened"
        >
          <path opacity="0.4" d="M8.6908 27H19.3092C23.9099 27 27 24.0412 27 19.6355V8.3645C27 3.9588 23.9099 1 19.3092 1H8.6908C4.0914 1 1 3.9601 1 8.3658L1 19.6355C1 24.0412 4.0914 27 8.6908 27Z" fill="url(#paint0_linear_685_17503)" />
          <path d="M19.59 12.1036C19.59 12.3565 19.4933 12.6107 19.3 12.804L14.7055 17.421C14.5188 17.6077 14.2659 17.7123 14.001 17.7123C13.7376 17.7123 13.4847 17.6077 13.298 17.421L8.70077 12.804C8.31415 12.416 8.31415 11.7884 8.70342 11.4005C9.0927 11.0138 9.72164 11.0152 10.1083 11.4031L14.001 15.3131L17.8938 11.4031C18.2805 11.0152 18.9081 11.0138 19.2973 11.4005C19.4933 11.5938 19.59 11.8493 19.59 12.1036Z" fill="#F6F6F6" />
          <defs>
            <linearGradient
              id="paint0_linear_685_17503"
              x1="25.375"
              y1="21.3125"
              x2="14"
              y2="-4.68751"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#02182D" />
              <stop offset="1" stop-color="#204E7A" />
            </linearGradient>
          </defs>
        </svg>
        <div class="pc-funds__title" @click="availableIsOpened = !availableIsOpened">
          {{ $t('pc.trade-limits.available-funds') }}
        </div>
        <div class="pc-funds__data">
          <template v-for="currency in Object.keys(balance)">
            <div v-if="Object.keys(balance[currency]).length" :key="currency">
              <icu-icon :class="`pc-${currency}`" />
              {{ balance[currency].sum_available }}
            </div>
          </template>
        </div>
      </pc-block>
      <pc-block class="pc-fund pc-funds__all" :class="{'is-opened':allIsOpened}">
        <svg
          class="pc-icon"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="allIsOpened = !allIsOpened"
        >
          <path opacity="0.4" d="M8.6908 27H19.3092C23.9099 27 27 24.0412 27 19.6355V8.3645C27 3.9588 23.9099 1 19.3092 1H8.6908C4.0914 1 1 3.9601 1 8.3658L1 19.6355C1 24.0412 4.0914 27 8.6908 27Z" fill="#515465" />
          <path d="M19.59 12.1036C19.59 12.3565 19.4933 12.6107 19.3 12.804L14.7055 17.421C14.5188 17.6077 14.2659 17.7123 14.001 17.7123C13.7376 17.7123 13.4847 17.6077 13.298 17.421L8.70077 12.804C8.31415 12.416 8.31415 11.7884 8.70342 11.4005C9.0927 11.0138 9.72164 11.0152 10.1083 11.4031L14.001 15.3131L17.8938 11.4031C18.2805 11.0152 18.9081 11.0138 19.2973 11.4005C19.4933 11.5938 19.59 11.8493 19.59 12.1036Z" fill="#F6F6F6" />
        </svg>
        <div class="pc-funds__title" @click="allIsOpened = !allIsOpened">
          {{ $t('pc.trade-limits.total-funds') }}
        </div>
        <div class="pc-funds__data">
          <template v-for="currency in Object.keys(balance)">
            <div v-if="Object.keys(balance[currency]).length" :key="currency">
              <icu-icon :class="`pc-${currency}`" />
              {{ balance[currency].sum_all }}
            </div>
          </template>
        </div>
      </pc-block>
      <pc-block class="pc-fund pc-funds__blocked" :class="{'is-opened':blockedIsOpened}">
        <svg
          class="pc-icon"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="blockedIsOpened=!blockedIsOpened"
        >
          <path opacity="0.4" d="M8.6908 27H19.3092C23.9099 27 27 24.0412 27 19.6355V8.3645C27 3.9588 23.9099 1 19.3092 1H8.6908C4.0914 1 1 3.9601 1 8.3658L1 19.6355C1 24.0412 4.0914 27 8.6908 27Z" fill="#FF5F00" />
          <path d="M19.59 12.1036C19.59 12.3565 19.4933 12.6107 19.3 12.804L14.7055 17.421C14.5188 17.6077 14.2659 17.7123 14.001 17.7123C13.7376 17.7123 13.4847 17.6077 13.298 17.421L8.70077 12.804C8.31415 12.416 8.31415 11.7884 8.70342 11.4005C9.0927 11.0138 9.72164 11.0152 10.1083 11.4031L14.001 15.3131L17.8938 11.4031C18.2805 11.0152 18.9081 11.0138 19.2973 11.4005C19.4933 11.5938 19.59 11.8493 19.59 12.1036Z" fill="#F6F6F6" />
        </svg>

        <div class="pc-funds__title" @click="blockedIsOpened=!blockedIsOpened">
          {{ $t('pc.trade-limits.blocked-funds') }}
        </div>
        <div class="pc-funds__data">
          <div>
            <icu-icon class="pc-uah" />
            {{ blocked || 0 }}
          </div>
        </div>
        <pc-button
          variant="error"
          :disabled="false"
          :no-padding="true"
        >
          <label class="pc-funds__add-doc">
            <div class="icon"></div>{{ $t('pc.trade-limits.add-document') }}
            <input type="file" @change="sendFile" />
          </label>
        </pc-button>
      </pc-block>
      <pc-block class="pc-fund pc-funds__limits" :class="{'is-opened':limitsIsOpened}">
        <svg
          class="pc-icon"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="limitsIsOpened=!limitsIsOpened"
        >
          <path opacity="0.4" d="M8.6908 27H19.3092C23.9099 27 27 24.0412 27 19.6355V8.3645C27 3.9588 23.9099 1 19.3092 1H8.6908C4.0914 1 1 3.9601 1 8.3658L1 19.6355C1 24.0412 4.0914 27 8.6908 27Z" fill="#FF5F00" />
          <path d="M19.59 12.1036C19.59 12.3565 19.4933 12.6107 19.3 12.804L14.7055 17.421C14.5188 17.6077 14.2659 17.7123 14.001 17.7123C13.7376 17.7123 13.4847 17.6077 13.298 17.421L8.70077 12.804C8.31415 12.416 8.31415 11.7884 8.70342 11.4005C9.0927 11.0138 9.72164 11.0152 10.1083 11.4031L14.001 15.3131L17.8938 11.4031C18.2805 11.0152 18.9081 11.0138 19.2973 11.4005C19.4933 11.5938 19.59 11.8493 19.59 12.1036Z" fill="#F6F6F6" />
        </svg>

        <div class="pc-funds__title" @click="limitsIsOpened=!limitsIsOpened">
          {{ $t('pc.trade-limits.invest-limits') }}
        </div>
        <div class="pc-funds__data">
          <div>
            <icu-icon class="pc-uah" />
            {{ investLimit || 0 }}
          </div>
        </div>

        <div class="pc-funds__title-2">
          {{ $t('pc.trade-limits.invest-limits-rest') }}
        </div>
        <div class="pc-funds__data">
          <div>
            <icu-icon class="pc-uah" />
            {{ investLimitRest || 0 }}
          </div>
        </div>
        <div class="pc-funds__note">
          {{ $t('pc.trade-limits.note-1') }}
        </div>
        <div class="pc-funds__note">
          {{ $t('pc.trade-limits.note-2') }}
        </div>
      </pc-block>
    </div>

    <pc-block>
      <div class="pc-block__title">
        {{ $t('pc.trade-limits.doc-archive') }}
      </div>
      <div class="pc-table">
        <div class="pc-table__header">
          <div
            v-for="column in columns"
            :key="column.title"
            class="pc-table__cell"
            :class="{'has-sort': column.hasSort}"
            @click="setSort(column.id)"
          >
            {{ $t(column.title) }}<icu-icon v-if="column.hasSort" class="pc-icon pc-sort" />
          </div>
        </div>
        <div v-for="row in data" :key="row.id" class="pc-table__row">
          <div class="pc-table__cell">
            <div>
              {{ row.doc }}
              <div class="media-tablet">
                {{ $t('pc.trade-limits.gk-confirm') }}
              </div>
            </div>

          </div>
          <div class="pc-table__cell">
            {{ $t('pc.trade-limits.gk-confirm') }}
          </div>
          <div class="pc-table__cell">
            {{ dateFormat(row.created) }}
          </div>
          <div class="pc-table__cell">
            <div class="media-mobile">
              <div>{{ row.date }}</div>
            </div>
            <div class="actions">
              <pc-download-progress v-if="row.is_loading" :progress="row.progress">
              </pc-download-progress>

              <div v-else class="pc-table__status" :class="{'rejected': row.status === 'REJECTED'}">
                <div v-if="row.status === 'IN_PROCESS'" class="pc-table__loader"></div>
                {{ $t(`pc.documents.${row.status}`) }}
              </div>
            </div>

          </div>
        </div>
      </div>
    </pc-block>
  </div>
</template>

<script>
import PcBlock from '@/components/views/PrivateCabinet/PcBlock'
import PcButton from '@/components/common/PcButton'
import IcuIcon from '@/components/common/IcuIcon'
import {api} from '@/api/api'
import PcDownloadProgress from '@/components/common/PcDownloadProgress.vue'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'PcTradeLimits',
  components: {PcDownloadProgress, IcuIcon, PcButton, PcBlock},
  manosry: null,
  data() {
    return {
      isUpdateDisabled: false,
      availableIsOpened: true,
      allIsOpened: false,
      blockedIsOpened: false,
      limitsIsOpened: false,

      columns: [
        {
          title: 'pc.documents.doc-name'
        },
        {
          title: 'pc.documents.doc-type',
        },
        {
          id: 'created',
          title: 'pc.documents.send-date',
          hasSort: true
        },
        {
          title: 'pc.documents.status',
        }
      ],
      data: [],
      limit: 20,
      offset: 0,
      hasNextPage: false,
      sort: null,
    }
  },
  computed: {
    ...mapGetters(['tradeLimitsData']),
    balance () {
      const balance = {
        uah: {},
        usd: {},
        eur: {}
      }
      if(this.tradeLimitsData.balances){
      this.tradeLimitsData.balances.forEach(el => {
        balance[el.currency.toLowerCase()] = el
      })
        }
      return balance
    },
    updateTime() {
      return this.tradeLimitsData.created
    },
    investLimit() {
      return  this.tradeLimitsData.limit
    },

    investLimitRest() {
      return this.tradeLimitsData.limit_rest
    },
    blocked() {
      return this.tradeLimitsData.sum_blocked
    }
  },
  async mounted() {
    await this.setTradeLimitsData()
    this.getConfirmationsList()
    this.$options.masonry = document.querySelector('.pc-content')
    this.$options.masonry.addEventListener('scroll', this.addScrollEvent)

  },
  beforeDestroy() {
    this.$options.masonry.removeEventListener('scroll', this.addScrollEvent)
  },
  methods: {
    ...mapActions(['setTradeLimitsData', 'updateTradeLimitsData']),
    setSort(id) {
      if(id) {
        if (this.sort === id) {
          this.sort = '-' + id
        } else {
          this.sort = id
        }
        this.getConfirmationsList()
      }
    },
    addScrollEvent() {
      if (this.$options.masonry.scrollTop + this.$options.masonry.clientHeight >= this.$options.masonry.scrollHeight - 1) {

        if (this.hasNextPage) {
          this.getConfirmationsList(true)
        }
      }
    },
    async getConfirmationsList(getNext = false) {
      if(getNext) {
        this.offset++
      } else {
        this.offset = 0
      }
      const params = {
        limit: this.limit,
        offset: this.offset * this.limit,
        doctype: this.filter,
        ordering: this.sort,
      }
      try {
        const { data } = await api.cabinet.getMoneyConfirmations(params)
        if(!getNext) {
          this.data = data.results
        } else {
          this.data.push(...data.results)
        }
        this.hasNextPage = data.next
      }catch(err) {
        console.log(err)
      }
    },

    async sendFile(event) {
      try {
        this.data.unshift({doc: event.target.files[0].name, is_loading: true, progress: 0})
        let formData = new FormData()
        formData.append('doc', event.target.files[0])
        await api.cabinet.sendMoneyConfirmation(formData, (progressEvent) => {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          this.data[0].progress = percentCompleted
        })
        this.getConfirmationsList()
      }catch(err) {
        this.$toast.error(this.$t('notifications.something-went-wrong'))
        console.log(err)
      }
    },



    async updateBalances(){
      this.isUpdateDisabled = true
      await this.updateTradeLimitsData()
      this.isUpdateDisabled = false
    },

    dateFormat(value) {
      if(value) {
        const date = new Date(value)
        return date.toLocaleString('ua-UA')
      }
      return ''
    }
  }


}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.pc-funds {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;

  & > div {
    flex-grow: 1;
    flex-basis: 50%;
  }
}

.pc-update{
  padding: 16px;

  &__info {
    display: flex;
    align-items: center;
    & > div {
      width: 50%;

      display: flex;
      flex-direction: column;
      align-items: stretch;
      color: $passive-text;
      font-size: 20px;
      span {
        display: block;
        width: 100%;
      }
    }

    span {
      color: inherit;
      display: block;
      width: 340px;
      flex-shrink: 0;
    }
  }

  &__btn {
    width: 100%;
    max-width: 346px;
    margin-left: 16px;
  }
}

.trade-limits {

  &__note {
    padding-top: 10px;
    color: $error-text !important;
    font-size: 12px;
    line-height: 16px;
  }
}
.pc-table__cell {
  flex-grow: 1;
  &:first-child {
    flex-basis: 30%;
    width: 30%;
    word-break: break-all;
  }
  &:nth-child(2) {
    flex-basis: 20%;
    width: 20%;
  }
  &:nth-child(3) {
    flex-basis: 15%;
    width: 15%;
  }
  &:last-child {
    flex-basis: 15%;
    width: 15%;
  }
}

.media-tablet {
  color: $passive-text;
  padding-top: 6px;
}
.media-mobile {
  padding-bottom: 6px;
}

@media (max-width: $desktop) {
  .pc-table__cell {

    &:nth-child(2) {
      display: none;
    }

  }

  .pc-update {
    &__btn {
      margin-left: 8px;
    }

    &__info {

      & > div {
        width: 50%;
        color: $passive-text;
        font-size: 20px;
        align-items: center;
        flex-shrink: 1;
        padding-right: 32px;
      }
    }
  }
}

@media (max-width: $tablet) {
  .pc-update{
    padding-left: 0;
    &__info {
      display: flex;
      align-items: center;
      padding-left: 20px;
      padding-right: 20px;

      & > div {
        width: 100%;
        color: $passive-text;
        font-size: 20px;
        align-items: center;
        padding-right: 0;
        span {
          text-align: center;
        }
      }
    }

  }

  .trade-limits__note {
    text-align: center;
  }
  .pc-table__cell {

    &:nth-child(3) {
      display: none;
    }
    &:nth-child(4) {
      flex-direction: column;
      align-items: flex-start;
    }

  }
}


</style>
